import { inject, Injectable } from '@angular/core';
import {
  LoadRosterStructureParams,
  RosterStructureRepository,
  Structure,
} from '@softapps/pms/roster-core';
import { ApiDataAccess, ApiResourceLocation } from '@softline/core';
import { SOFTLINE_API_SOFTLINE_TICKET_ROSTER_STRUCTURE } from '../roster.api';

@Injectable()
export class SoftlineRosterStructureRepository extends RosterStructureRepository<Structure> {
  readonly #dataAccess = inject(ApiDataAccess);

  async load(params: LoadRosterStructureParams): Promise<Structure> {
    const location: ApiResourceLocation = {
      path: SOFTLINE_API_SOFTLINE_TICKET_ROSTER_STRUCTURE,
      pathParams: { employeeId: params.employeeId },
      queryParams: {
        begindate: params.begindate,
        enddate: params.enddate,
      },
    };

    return this.#dataAccess.get(location);
  }
}
